var WeeklyTargetLegend = {
    not_started: {
        color: '#F34456',
        fill: 100,
        title: 'not started',
    },
    started: {
        color: '#FFC500',
        fill: 0,
        title: 'started',
    },
    '1/4_completed': {
        color: '#FFC500',
        fill: 25,
        title: 'completed 1/4',
    },
    half_completed: {
        color: '#FFC500',
        fill: 50,
        title: 'completed half',
    },
    '3/4_completed': {
        color: '#FFC500',
        fill: 75,
        title: 'completed 3/4 ',
    },
    completed: {
        color: '#6BAE46',
        fill: 100,
        title: 'completed',
    },
};
var WEEKLY_LEGEND_STATUSES = Object.keys(WeeklyTargetLegend);
export { WeeklyTargetLegend, WEEKLY_LEGEND_STATUSES };
